// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2026-10-12 21:19:39 +0200 (Mon, 12 Oct 2026) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 166505 $
// Purpose     : notification reducers
// =============================================================================
// ---Third-party imports
import { handleActions } from 'redux-actions';
// ---Framework imports
import log from 'uix/logging';
// ---Local imports
import * as A from './actions';
// ---Globals
function filterNotifications(notifications, id) {
    return notifications.filter((notification)=>notification.id !== id);
}
// this also kills all old visibles from store
const MAX_NOTIFICATIONS = 10;
// repeated requests of a failing part push the very same error again and again,
// keep only the newest toast for identical notifications that are still visible
const isDuplicateOf = (notification, payload)=>notification.visible && notification.type === payload.type && notification.header === payload.header && notification.message === payload.message && notification.details === payload.details;
const handleShowNotification = (data, { payload })=>({
        ...data,
        notify: [
            payload,
            ...filterNotifications(data.notify, payload.id).filter((n)=>!isDuplicateOf(n, payload))
        ].slice(0, MAX_NOTIFICATIONS)
    });
export const data = [
    handleActions(new Map([
        [
            A.showNotification,
            handleShowNotification
        ],
        [
            A.successNotification,
            handleShowNotification
        ],
        [
            A.warningNotification,
            handleShowNotification
        ],
        [
            A.errorNotification,
            handleShowNotification
        ],
        [
            A.clearAllNotifications,
            (data, { payload })=>({
                    ...data,
                    notify: data.notify.map((n)=>({
                            ...n,
                            visible: false
                        }))
                })
        ],
        [
            // stale api errors must not follow the user into the next view
            'ACTIVATE_VIEW',
            (data)=>({
                    ...data,
                    notify: data.notify.map((n)=>n.type == 'ERROR' ? {
                            ...n,
                            visible: false
                        } : n)
                })
        ],
        [
            A.dismissNotification,
            (data, { payload })=>({
                    ...data,
                    notify: data.notify.map((n)=>payload.id == n.id ? {
                            ...n,
                            visible: false
                        } : n)
                })
        ]
    ]), {
        notify: []
    })
];
